import { Col, Container, Row } from 'reactstrap';
import { useTheme } from 'Hooks';
import { LoadingSpinner, FontAwesome } from 'Elements';
import { clx } from 'src/helpers/Utils';
import { Statistic } from 'src/types/BusinessPartner';

type Props = {
	isLoadingProfile: boolean;
	color: number;
	statisticItems: Statistic[];
	statistics: {
		enabled: boolean;
	};
};

export const CommunityPartnerPreviewStatisticSection = ({
	isLoadingProfile,
	statistics,
	color,
	statisticItems
}: Props) => {
	const { theme } = useTheme();
	return (
		<section className="position-relative mb-5">
			<Container>
				{isLoadingProfile && (
					<div className="d-flex align-items-center justify-content-center my-4 py-4">
						<LoadingSpinner />
					</div>
				)}
				{!isLoadingProfile && statistics && (
					<Row
						className={`d-flex justify-content-center mx-lg-5 pt-3`}>
						{statisticItems?.map((item) => {
							if (
								!item ||
								item.text == null ||
								item.text.trim() === ''
							) {
								return null;
							}
							return (
								<Col
									key={item.title + item.text}
									sm={6}
									md={3}
									className="mb-4">
									<div
										className={clx(
											'd-flex flex-column align-items-center justify-content-center text-center gap-2'
										)}>
										<FontAwesome
											icon={item?.icon}
											size="3x"
											color={
												color?.toString() ??
												theme.businessPartner
													.primaryColor
											}
										/>
										<h5 className="h6 lh-base mb-0 mt-2 text-gray-5">
											{item.title}
										</h5>
										<div className="text-break lh-base w-100 fs-base">
											{item.text}
										</div>
									</div>
								</Col>
							);
						})}
					</Row>
				)}
			</Container>
			{!isLoadingProfile && !statistics?.enabled && (
				<div className="overlay overlay_white overlay-box" />
			)}
		</section>
	);
};
